import { css } from '@emotion/core';
import { tokens, shadow, getCssVariableValue } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
var colors = tokens.colors,
  shadows = tokens.shadows;
export var tooltipWidth = 282;
export var colours = () => ({
  scaleTextColour: getCssVariableValue(colors.neutral.medium.default),
  scaleLineColour: getCssVariableValue(colors.neutral.trim.default),
  axisColour: getCssVariableValue(colors.info.medium.default),
  pointBackgroundColour: getCssVariableValue(colors.neutral.surface.default),
  xScaleGridColour: getCssVariableValue(colors.neutral.heavy.default)
});
export var lineGraph = _ref => {
  var height = _ref.height;
  return /*#__PURE__*/css("position:relative;height:", height, "px;");
};
export var tooltip = _ref2 => {
  var left = _ref2.left,
    top = _ref2.top;
  return /*#__PURE__*/css("position:absolute;left:", left, "px;top:", top, "px;width:", tooltipWidth, "px;padding:16px;border-radius:3px;box-shadow:", shadow(shadows.elevation3), ";background-color:", colors.neutral.surface.default, ";pointer-events:none;color:", colors.neutral.heavy.default, ";transform:translateY(-50%);");
};
export var tooltipHeading = /*#__PURE__*/css(designTokenFonts.bodyBold, " margin-bottom:8px;");
export var dataItem = {
  name: "3mllz6",
  styles: "display:flex;justify-content:space-between;margin-bottom:8px;"
};
export var dataItemLabel = /*#__PURE__*/css("display:flex;align-items:baseline;", designTokenFonts.body);
export var dataItemValue = /*#__PURE__*/css(designTokenFonts.bodyBold);
export var roundel = _ref3 => {
  var colour = _ref3.colour;
  return /*#__PURE__*/css("position:relative;top:3px;height:16px;width:16px;border-radius:8px;border:4px solid ", colour, ";margin-right:4px;");
};